import { Component, Inject } from "@angular/core";
import { ApiService } from "app/api.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatDialog } from "@angular/material/dialog";
@Component({
  selector: "app-sales-order-file-modal",
  templateUrl: "./sales-order-file-modal.component.html",
  styleUrls: ["./sales-order-file-modal.component.scss"],
})
export class SalesOrderFileModalComponent {
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  allItemIds: number[] = [];
  showLoader: boolean = false;
  selectedItems: boolean = false;
  test: boolean = true;
  images: any[] = [];
  image_data: any;
  deleteIds: { id: number; name: string }[] = [];
  isViewMode: boolean = false;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<SalesOrderFileModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {id?: any; name?: string;  uploadedFiles?: any[];  images?: any[];   isViewMode?: boolean; 
 }
  ) {
    this.isViewMode = this.data.isViewMode || false;
    console.log("Fetched Name:", this.data);
  }

  ngOnInit(): void {
    this.showLoader = true;

    if (this.data.images) {
      this.processUploadedFiles(this.data.images);
    } else if (this.data.id) {
      this.fetchImagesById(this.data.id);
    }
  }

  processUploadedFiles(files: any[]): void {
    this.imageUrls = [];
    this.documentUrls = [];

    for (let file of files) {
      if (this.isImage(file.extension)) {
        this.imageUrls.push(file);
      } else if (this.isDocument(file.extension)) {
        this.documentUrls.push(file);
      }
    }

    this.showLoader = false;
  }

  fetchImagesById(id: number): void {
    this.allItemIds = [];
    this.imageUrls = [];
    this.documentUrls = [];
    this.showLoader = true;

    this.apiService.getSalesOrderFiles(id).subscribe(
      (data: any) => {
        console.log("Fetched Data:", data);

        if (data.uploadedFiles && data.uploadedFiles.length) {
          for (let file of data.uploadedFiles) {
            if (this.isImage(file.extension)) {
              this.imageUrls.push(file);
              this.allItemIds.push(file.id);
            } else if (this.isDocument(file.extension)) {
              this.documentUrls.push(file);
              this.allItemIds.push(file.id);
            }
          }
        }

        this.showLoader = false;
      },
      (error) => {
        console.error("Error fetching images:", error);
        this.showLoader = false;
      }
    );
  }

  isImage(extension: string): boolean {
    return ["jpg", "jpeg", "png", "gif"].includes(extension.toLowerCase());
  }

  isDocument(extension: string): boolean {
    return ["pdf", "doc", "docx", "xls", "xlsx"].includes(
      extension.toLowerCase()
    );
  }
  onCheckboxChange(id: number, name: string, type: 'image' | 'document'): void {
    const index = this.deleteIds.findIndex(item => item.id === id && item.name === name);
  
    if (index === -1) {
      this.deleteIds.push({ id, name });
    } else {
      this.deleteIds.splice(index, 1);
    }
    this.selectedItems = this.deleteIds.length > 0;
    console.log("Selected Files for Deletion:", this.deleteIds);
  }

  openModal(): void {
    const dialogRef = this.dialog.open(SalesOrderFileModalComponent, {
      width: "1200px",
      height: "600px",
      data: { id: this.data.id, images: this.image_data },
    });
  }

  deleteImg(): void {
    this.showLoader = true;
    const filesToDelete = this.deleteIds.map(file => ({
      id: file.id,
      name: file.name
    }));
    this.apiService.deleteSoImage(this.data.id, filesToDelete).subscribe(
      (response) => {
        console.log("Files deleted successfully:", response);
          alert("files deleted succesfully");

        this.imageUrls = this.imageUrls.filter(file =>
          !this.deleteIds.some(delFile => delFile.id === file.id && delFile.name === file.name)
        );
  
        this.documentUrls = this.documentUrls.filter(file =>
          !this.deleteIds.some(delFile => delFile.id === file.id && delFile.name === file.name)
        );
        this.deleteIds = [];
        this.fetchImagesById(this.data.id);
      },
      (error) => {
        console.error("Error deleting files:", error);
      },
      () => {
        this.showLoader = false;
      }
    );
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
